import { useFieldArray, useForm, useFormContext } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { generateUUID } from '@dealstack/frontend/shared/other/react/generateUUID.ts';
import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2.tsx';
import { z } from 'zod';
import {
	CREATE_TEMPLATE_FORM_FIELDS,
	templateCustomDetailDefinitionShape,
} from '@dealstack/frontend/admin/pages/Manage/ManagePreFillableForms/CreatePreFillableForm/useCreatePreFillableFormController.ts';

const manageCustomDetailsDefinitionsFormShape = z.object({
	customDefinitions: z.array(templateCustomDetailDefinitionShape),
});
type ManageCustomDetailsDefinitionsForm = z.infer<typeof manageCustomDetailsDefinitionsFormShape>;

export const useManageCustomDetailsDefinitionsModalController = ({
	onClose,
}: {
	onClose: () => void;
}) => {
	const mainForm = useFormContext();

	const manageCustomDetailsDefinitionsForm = useForm<ManageCustomDetailsDefinitionsForm>({
		mode: 'all',
		defaultValues: {
			customDefinitions:
				mainForm.getValues(CREATE_TEMPLATE_FORM_FIELDS.CUSTOM_DETAIL_DEFINITIONS) ?? [],
		},
		resolver: zodResolver(manageCustomDetailsDefinitionsFormShape),
	});

	const { fields, append, remove } = useFieldArray<ManageCustomDetailsDefinitionsForm>({
		name: 'customDefinitions',
		control: manageCustomDetailsDefinitionsForm.control,
	});

	const onAddNewClicked = () => {
		append({
			name: '',
			instruction: '',
			localId: generateUUID(),
		});
	};

	const onRemoveClicked = (arrayIndex: number) => {
		remove(arrayIndex);
	};

	const onSubmit = async ({ customDefinitions }: ManageCustomDetailsDefinitionsForm) => {
		mainForm.setValue(CREATE_TEMPLATE_FORM_FIELDS.CUSTOM_DETAIL_DEFINITIONS, customDefinitions);

		showToastV2({ message: 'Saved' });
		onClose();
	};

	return {
		manageCustomDetailsDefinitionsForm,
		fields,
		onRemoveClicked,
		onAddNewClicked,
		onSubmit,
	};
};
